
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"remove\":true,\"id\":1}!css?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-8370082e&scoped=true!postcss!sass!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Idols.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Idols.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-8370082e!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Idols.vue"),
  /* scopeId */
  "data-v-8370082e",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./views/popularize/Idols.vue
// module id = 1100
// module chunks = 0